﻿/*==================================================
 *  Common localization strings
 *==================================================
 */

Timeline.strings["vi"] = {
    wikiLinkLabel:  "Bàn luận"
};




//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/vi/timeline.js
// module id = 593
// module chunks = 3